import React from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { isProductKeywordAlreadyExists } from "../../actions/imagedatabase/products";
import { isProductFamilyKeywordAlreadyExists } from "../../actions/imagedatabase/productsFamilies";
import { connect } from "react-redux";

class KeywordModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      keyword: this.props.keyword || "",
      keywordError: "",
    };
  }

  confirm() {
    this.props.keyword
      ? this.props.update(this.state.keyword)
      : this.props.add(this.state.keyword);
    this.props.closeModal();
  }

  isKeywordAlreadyExists(imageType, keyword) {
    if (!imageType || !keyword) return;

    switch (imageType) {
      case "family":
        this.props.onGetIsProductFamilyKeywordAlreadyExists(
          keyword.toUpperCase(),
          () =>
            this.setState({
              keywordError: <FormattedMessage id="Keyword.Already.Exists" />,
            }),
          () => this.setState({ keywordError: "" }),
        );
        break;
      case "product":
        this.props.onGetIsProductKeywordAlreadyExists(
          keyword,
          () =>
            this.setState({
              keywordError: <FormattedMessage id="Keyword.Already.Exists" />,
            }),
          () => this.setState({ keywordError: "" }),
        );
        break;
      default:
        return console.log("image type doesn't exists");
    }
  }

  render() {
    return (
      <Modal
        show={true}
        onHide={() => this.props.closeModal()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage
              id={this.props.keyword ? "Modify.Keyword" : "Add.Keyword"}
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {this.props.keyword && (
            <Alert variant="warning">
              <h6>
                <FormattedMessage id="Warning" />
              </h6>
              <p>
                <FormattedMessage id="Keyword.Warning" />
              </p>
            </Alert>
          )}
          <Form>
            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Keyword" />
              </Form.Label>
              <Form.Control
                type="text"
                value={this.state.keyword}
                isInvalid={this.state.keywordError !== ""}
                onChange={(e) =>
                  this.setState({ keyword: e.target.value.toUpperCase() })
                }
                onBlur={() =>
                  this.isKeywordAlreadyExists(
                    this.props.imageType,
                    this.state.keyword,
                  )
                }
              />
              <Form.Control.Feedback type="invalid">
                {this.state.keywordError}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="info"
            disabled={
              this.state.keyword === this.props.keyword ||
              this.state.keyword === "" ||
              this.state.keywordError !== ""
            }
            onClick={() => this.confirm()}
          >
            <FormattedMessage id="Confirm" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetIsProductKeywordAlreadyExists: (
      keyword,
      existsCallback,
      noExistsCallback,
    ) =>
      dispatch(
        isProductKeywordAlreadyExists(
          keyword,
          existsCallback,
          noExistsCallback,
        ),
      ),
    onGetIsProductFamilyKeywordAlreadyExists: (
      keyword,
      existsCallback,
      noExistsCallback,
    ) =>
      dispatch(
        isProductFamilyKeywordAlreadyExists(
          keyword,
          existsCallback,
          noExistsCallback,
        ),
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(KeywordModal));
